export const AUTH_STORAGE_KEY = 'AUNTIE_APP_AUTH_KEY';
export const USER_STORAGE_KEY = 'AUNTIE_APP_AUTH_KEY';
export const USER_PROFILE_STORAGE_KEY = 'AUNTIE_APP_PROFILE_KEY';
export const ONBOARDING_STORAGE_KEY = 'AUNTIE_APP_AUTH_KEY';